import React from "react";

const SwiperControls = () => {
  return (
    <div className="slider-controler">
      <div className="swiper-pagination"></div>
    </div>
  );
};

export default SwiperControls;
